import Vue from "vue";
import Router from "vue-router";
import myDocuments from "../views/MyDocuments.vue";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            name: "myDocuments",
            component: myDocuments,
            props: { isPublic: true }
        }
    ]
});
